import React, { Component } from "react";
import { Link } from "react-router-dom";

import Page from "../containers/Page";
import "./Footer.css";

class Footer extends Component {
  render() {
    // Prevent the footer from rendering if the rest of the page content has
    // not been shown yet.
    if (!this.props.isPageLoaded) {
      return <div />;
    }

    return (
      <div className="type-footer-container">
        <div className="type-footer-actions">
          {this.props.user
            ? <ul className="list-inline">
                {this.props.pageMode === Page.Mode.EDIT
                  ? <li>
                      <Link to={this.props.pagePath}>exit edit mode</Link>
                    </li>
                  : <li>
                      <Link to={`${this.props.pagePath}/_edit`}>edit page</Link>
                    </li>}
                <li>
                  <Link to="/logout">logout</Link>
                </li>
                <li>
                  <Link to="/sandbox">sandbox</Link>
                </li>
              </ul>
            : <ul className="list-inline">
                <li>
                  <Link to="/login">login</Link>
                </li>
              </ul>}
        </div>
      </div>
    );
  }
}

// NOTE: Wrapping Footer with withRouter doesn't seem to show router match
// parameters. Thus, we move Footer into Page.
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js